const DEFAULT_ISO_CODE = 'EUR';

const currencySymbolMap = new Map([
  ['EUR', '€'],
  ['GBP', '£'],
  ['USD', '$'],
  ['AED', 'AED'],
  ['TRY', 'TL'],
  ['PLN', 'zł'],
  ['HUF', 'Ft'],
  ['CZK', 'Kč']
]);

class CurrencyFormatter {
  constructor(isoCode) {
    this.isoCode = currencySymbolMap.has(isoCode) ? isoCode : DEFAULT_ISO_CODE;
  }

  getIsoCode() {
    return this.isoCode;
  }

  getLabel() {
    return this.isoCode;
  }

  getSymbol() {
    return currencySymbolMap.get(this.isoCode);
  }
}

export const getCurrencySymbol = (isoCode = DEFAULT_ISO_CODE) =>
  currencySymbolMap.get(isoCode);

export default CurrencyFormatter;
